import type { PropsWithChildren } from 'react';
import { MantineProvider } from '@mantine/core';

import { GamecenterModalsContextProvider as BaseProvider } from './GamecenterModalsContext';
import GamecenterModals from './GamecenterModals';

function GamecenterModalsContextProvider({ children }: PropsWithChildren) {
  return (
    <BaseProvider>
      {children}
      <MantineProvider inherit theme={{ colorScheme: 'light', globalStyles: undefined }}>
        <GamecenterModals />
      </MantineProvider>
    </BaseProvider>
  );
}

export default GamecenterModalsContextProvider;
